import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function SessionRoleUpdatedNotification({ id, i18nKey, onDismiss }) {
    const { t } = useTranslation();
    return (
        <Snackbar id={id} onDismiss={onDismiss} variant={SnackbarVariant.DEFAULT} autoHideEnabled>
            <SnackbarMessage>{t(i18nKey)}</SnackbarMessage>
        </Snackbar>
    );
}
